import {
  getSegmentationData,
  toImageDataUrl,
  getHairPredictionResult,
  getUnknownHairPredictionResult,
} from '../components/chat/utils/hairAnalysisHelpers'
import {
  createHairSegmentation,
  extractHairAttributes,
} from '../components/chat/services/hairAnalysisService'

const useHairAnalysis = ({
  environment,
  isTrial,
  agentId,
  dispatch,
}) => {
  const predictHairAttributes = async (photoUrl) => {
    let maskedImage = null

    try {
      const payload = await createHairSegmentation({
        photoUrl,
        environment,
        isTrial,
        agentId,
      })

      const {
        segmentedImageRaw,
        realHairSegmentedRaw,
      } = getSegmentationData(payload)

      dispatch({
        type: 'SET_SEGMENTED_RAW_IMAGE',
        payload: realHairSegmentedRaw,
      })

      if (!segmentedImageRaw) {
        throw new Error(
          'segmented_image missing from segmentation response',
        )
      }

      maskedImage = toImageDataUrl(segmentedImageRaw)

      if (!realHairSegmentedRaw) {
        throw new Error(
          'real_hair_segmented missing from segmentation response',
        )
      }

      const vlmData = await extractHairAttributes(
        realHairSegmentedRaw,
      )

      return getHairPredictionResult({
        maskedImage,
        vlmData,
      })
    } catch (error) {
      return getUnknownHairPredictionResult(maskedImage)
    }
  }

  return {
    predictHairAttributes,
  }
}

export default useHairAnalysis